import { createStructuredSelector } from 'reselect';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import BankAccounts from 'modules/Profile/components/BankAccounts';
import { bankAccountsReset, fetchBankAccounts } from 'modules/Profile/redux/bankAccounts/actions';
import {
  russianBankAccounts,
  russianBankAccountsError,
  russianBankAccountsIsDataPresented,
  russianBankAccountsLoading,
  russianBankAccountsPaginationOption,
} from 'modules/Profile/components/BankAccounts/selectors';
import { formValues, reduxForm } from 'redux-form/immutable';
import { get } from 'lodash';

const mapStateToProps = createStructuredSelector({
  bankAccounts: russianBankAccounts,
  paginationOptions: russianBankAccountsPaginationOption,
  isLoading: russianBankAccountsLoading,
  isError: russianBankAccountsError,
  isDataPresented: russianBankAccountsIsDataPresented,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchBankAccounts,
      bankAccountsReset,
    },
    dispatch,
  );
export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'russianBankAccounts',
    destroyOnUnmount: true,
    onChange(values, dispatch, props) {
      const formValues = values.toJS();
      const dateRange = get(formValues, 'filter.dateRange');
      const search = get(formValues, 'filter.search');
      const onlyOpened = get(formValues, 'filter.onlyOpened');
      const dateFrom = get(dateRange, [0]);
      const dateTo = get(dateRange, [1]);
      const sort = get(formValues, 'sort');
      const pagination = get(formValues, 'pagination');
      props.fetchBankAccounts({
        filter: { search, onlyOpened, dateFrom, dateTo },
        sort,
        pagination,
      });
    },
  }),
  formValues({
    sort: 'sort',
    filter: 'filter',
  }),
)(BankAccounts);
